/**
 * @author Vivek <vivek.kumar@314ecorp.com>
 * @description Search component for guarantors
 */
import { useMemo } from 'react';

import { IFieldsData } from 'lib/SearchQueryBuilder/config/entity.config';
import { useGuarantorStoreActions, useGuarantorStoreValues } from 'store/guarantor';
import AdvancedFilters from 'components/advancedFilters';
import { FieldTypeConfigs } from 'components/forms/schema/claimsAdvancedFilterSchema';
import { SEARCH_FIELDS_META } from 'app-constants/accounts';

const filterDataKeys = {
	guarantorName: 'guarantorName',
	patientName: 'patientName',
	patientMRN: 'patientMRN',
	accountNumber: 'accountNumber',
};

const GuarantorSearch: React.FC = () => {
	const { searchParams } = useGuarantorStoreValues();
	const { setSearchParams, setApiParams } = useGuarantorStoreActions();

	const filterSchema: IFieldsData[] = useMemo(
		() => [
			{
				...FieldTypeConfigs.text,
				field: filterDataKeys.guarantorName,
				display_name: SEARCH_FIELDS_META.guarantorName.label,
				isSearchable: true,
				custom_props: {
					placeholder: SEARCH_FIELDS_META.guarantorName.placeholder,
				},
			},
			{
				...FieldTypeConfigs.text,
				field: filterDataKeys.patientName,
				display_name: SEARCH_FIELDS_META.patientName.label,
				isSearchable: true,
				custom_props: {
					placeholder: SEARCH_FIELDS_META.patientName.placeholder,
				},
			},
			{
				...FieldTypeConfigs.text,
				field: filterDataKeys.patientMRN,
				display_name: SEARCH_FIELDS_META.patientMRN.label,
				isSearchable: true,
				custom_props: {
					placeholder: SEARCH_FIELDS_META.patientMRN.placeholder,
				},
			},
			{
				...FieldTypeConfigs.text,
				field: filterDataKeys.accountNumber,
				display_name: SEARCH_FIELDS_META.accountNumber.label,
				isSearchable: true,
				custom_props: {
					placeholder: SEARCH_FIELDS_META.accountNumber.placeholder,
				},
			},
		],
		[],
	);

	return (
		<AdvancedFilters
			initialValue={searchParams || {}}
			filterSchema={filterSchema}
			hideFilterButton={true}
			onSubmit={(newParams) => {
				setSearchParams(newParams);
				setApiParams({ criteria: newParams?.filterParams });
			}}
		/>
	);
};

export default GuarantorSearch;
